module.exports = __webpack_public_path__ + "img/42.2.TN.9bb52090.png";